export default "__VITE_ASSET__2ff50bad__"